'use client';

import { c as _c } from "react/compiler-runtime";
import * as CookieConsent from 'vanilla-cookieconsent';
import { css } from 'styled-system/css';

/**
 * Persistent entry point to reopen the consent preferences (Art. 7 Abs. 3
 * DSGVO — withdrawal must be as easy as consent). Rendered in the footer next
 * to Impressum/Datenschutz. Uses the global vanilla-cookieconsent API, which is
 * initialized by ConsentProvider on every page.
 */
export function CookieSettingsButton() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <button type="button" onClick={_temp} className={css({
      cursor: "pointer",
      background: "none",
      border: "none",
      padding: "0",
      font: "inherit",
      color: "text.muted",
      _hover: {
        color: "palette.orange"
      },
      transition: "color 0.15s"
    })}>Cookie-Einstellungen</button>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}
function _temp() {
  return void CookieConsent.showPreferences();
}